import * as S from '../scss/theme';
// import styled from 'styled-components'; 
import React, { useState, useEffect, useRef, useMemo } from 'react';
import JoditEditor from 'jodit-react';
import './BoardDetail.scss';
import Button from '../comm/HongButton';
import { useNavigate } from 'react-router-dom';
import fnc from '../mymod/commFunction';
import BoardUpdate from './BoardUpdate';
// import usePreventRefresh from '../common/usePreventRefresh';

import { useSelector, useDispatch } from 'react-redux';
import { setSelectedList, setInitialPage, setIsRefreshBoard} from "../reduxToolkit/reduxBoard";


const BoardDetail = ({ setIsModal }) => {

    // usePreventRefresh();
    
    const navigate = useNavigate();

    const editor = useRef(null);
    const [content, setContent] = useState('');
    const [isModal_update, setIsModal_update] = useState(false);

    const boardTitle = useSelector(state => state.reduxStoreBoard.boardTitle);
    const selectedList = useSelector(state => state.reduxStoreBoard.selectedList);
    const selectedListFile = useSelector(state => state.reduxStoreBoard.selectedListFile);
    const boardKind = useSelector(state => state.reduxStoreBoard.boardKind);
    const isAdmin = useSelector(state => state.reduxStoreBoard.isAdmin);
    const isRefreshBoard = useSelector(state => state.reduxStoreBoard.isRefreshBoard);

    const dispatch = useDispatch();

    

    useEffect(() => {
      if (selectedList) {
        fncSelectBoardDetail();
      }    
    }, [selectedList, isModal_update]);


    const config = useMemo(() => ({
            readonly: true, // Jodit의 모든 옵션은 https://xdsoft.net/jodit/docs/ 에서 확인할 수 있습니다
            toolbar: false, 
            statusbar: false, // 상태 표시줄 숨기기
            colorPickerDefaultTab: "text", // 기본 탭을 텍스트로 설정
            style: {
              textAlign: 'left', // 기본 텍스트 왼쪽 정렬
          },
          

      }), [] );

   
 
    function fncSelectBoardDetail() {  
        fnc.sendAxios('/boardRoutes/boardDetail', { sno : selectedList.sno }, (res) => {
          if (res) {
            setContent(res[0]?.content || '');
            window.scrollTo(0, 0);//스크롤
          } else {
            console.log("속성이 obj 내에 없습니다.");
          }
        });
      }
  
   
      function fncUpdate(item) {//새로 추가됨(content는 list에서 용량상 안 가져와서)
        dispatch(setSelectedList({ ...selectedList, content: content }));
        setIsModal_update(true);
      }

      function fncDelete() { 
        if (!window.confirm("정말로 삭제하시겠습니까?")) {
          return;
        }
        fncDeleteBoardSQL();    
      }

    
      function fncDeleteBoardSQL() {
          fnc.sendAxios('/delete_board', { sno: selectedList.sno }, (response) => {       
          if (response) {
            dispatch(setInitialPage(0));
            onPrev();
          } else {
            console.log("속성이 obj 내에 없습니다.");
          }
        });

      }

      function onPrev() {
        setIsModal(false);
        dispatch(setIsRefreshBoard(!isRefreshBoard));
     
      }


    //=========================================================================
    return (

      <>
    {selectedList.sno &&  <div className='frame_boardDetail'>
        
          {/* 깜빡임 제거 */}
          {true && <div className='box_jodit'> 
                <div className='box_itemTitle'>  
                    <p className='itemTitle'>{selectedList.title}</p>
                    <p className='itemDate'>{selectedList.date}</p>
                </div>

                <div className='box_edit'>

                    {content && <JoditEditor
                        ref={editor}
                        value={content}
                        config={config}
                        tabIndex={1} // 텍스트 영역의 tabIndex
                        onBlur={newContent => setContent(newContent)}
                        onChange={newContent => {}} 
                    />}

                  <div className='box-menu'>
                  <Button className="btn h-btn-gray "  onClick={onPrev}>목록보기</Button>
                  {isAdmin && <Button className='btn h-btn-blue' onClick={fncUpdate}>수정</Button>}
                  {isAdmin && <Button className='btn h-btn-red'  onClick={fncDelete}>삭제</Button>}
            
                </div>
                </div>

          </div>}
        
      </div> }

       {isModal_update && <div className='box_modal'>
               <BoardUpdate setIsModal_update={setIsModal_update}/>
        </div> }     
      
     </>

    );
};

export default BoardDetail;
